.initial-wrapper {
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    width: 86px;
    height: 48px;
  }
}

.initial-loading {
  width: 100%;
  text-align: center;

  span {
    margin: 0 20px;
  }
}

.initial-alert {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.initial-error-msg {
  margin: 1em;
  text-align: center;
}
